<div fxFlex [fxLayoutAlign]="wrapperLayoutAlign" fxLayoutGap="25px">

  <div [fxFlex]="labelFlex" *ngIf="hasTextLabel">
    {{ textLabel | translate }}*
  </div>

  <div [fxFlex]="formWrapperFlex">
    <form [formGroup]="formGroup"> 
      <mat-form-field class="width-100">
        <mat-chip-list #chipsRecipient aria-label="Recipient" required>
          <mat-chip *ngFor="let data of multiSelect.selectedRecipients" [removable]="true" (removed)="toggleSelection(data, recipients, 'selectedRecipients', 'recipient')">
            {{data.reference_code != 'all' ? (data.reference_code + ' - ' + data.fullname) : data.fullname }}
            <mat-icon matChipRemove>cancel</mat-icon>
          </mat-chip>
        
          <input 
            matInput 
            [required]=""
            #recipientInput 
            [matChipInputFor]="chipsRecipient" 
            [placeholder]="placeHolder"
            formControlName="recipient" 
            [matChipInputAddOnBlur]="true"
            [matAutocomplete]="recipientAC" 
            (focus)="!loading.recipient && getInitialValues('recipient')" 
            (blur)="checkAutocompleteObject(formGroup, 'recipient', 'selectedRecipients')"
            >
        
          <!-- <mat-icon *ngIf="recipientInput.value" matSuffix svgIcon="close-circle-outline" (click)="resetControl(formGroup.get('recipient')); recipientInput.value = ''"></mat-icon> -->
        
          <mat-icon 
            matSuffix 
            svgIcon="menu-down" 
            *ngIf="!recipientInput.value" 
            class="autocomplete-arrow-color cursor-pointer"
            (click)="recipientInput.focus()" 
            >
          </mat-icon>
        </mat-chip-list>
 
        <mat-autocomplete 
          id="id_recipient_dropdown"
          [displayWith]="displayFn"
          #recipientAC="matAutocomplete" 
          (opened)="autocompleteScroll('recipient','recipientAC','recipientACTr')"
          (closed)="autoCmpltClosed()"
          >
        <mat-option
          disabled
          *ngIf="!loading.recipient && recipients?.length == 0"
          >
          {{ 'MSG_NO_DATA' | translate }}
        </mat-option>

        <ng-container>
          <mat-option [id]="'id_recipient_data_' + (i+1)" *ngFor="let data of recipients; let i = index" [value]="data" [disabled]="data.disabled">
            <div (click)="optionClicked($event, data, recipients, 'selectedRecipients', 'recipient', recipientInput)" [class.disable]="data.disabled">
              <mat-checkbox [id]="'id_recipient_data_checkbox' + (i+1)" [checked]="data.selected" (change)="toggleSelection(data, recipients, 'selectedRecipients', 'recipient', recipientInput)" (click)="$event.stopPropagation()" [disabled]="data.disabled">
                {{data.reference_code != 'all' ? (data.reference_code + ' - ' + data.fullname) : data.fullname }}
              </mat-checkbox>
            </div>
          </mat-option>
        </ng-container>
      
        <mat-option *ngIf="loading.recipient" disabled>
          <mat-spinner color="primary" class="spinner-margin-auto" mode="indeterminate" [diameter]="45"></mat-spinner>
        </mat-option>
      </mat-autocomplete>

        <mat-error *ngIf="formGroup.get('recipient').hasError('required')">
          {{ 'MSG_FIELD_REQUIRED' | translate }}
        </mat-error>

        <mat-error *ngIf="formGroup.get('recipient').hasError('notExisting')">
          {{ 'MSG_DOESNT_EXIST' | translate: {type: 'LABEL_GROUP' | translate} }}
        </mat-error>
      </mat-form-field>
    </form>
  </div>
  
</div>